import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FiArrowUpRight, FiMenu, FiX } from 'react-icons/fi';
import LanguageToggle from '../ui/LanguageToggle';

interface HeaderProps {
  currentPath: string;
}

const labels = {
  pt: {
    solutions: 'Soluções',
    system: 'Como funciona',
    projects: 'Projetos',
    product: 'Social Manager',
    process: 'Processo',
    contact: 'Falar sobre um projeto',
  },
  en: {
    solutions: 'Solutions',
    system: 'How it works',
    projects: 'Projects',
    product: 'Social Manager',
    process: 'Process',
    contact: 'Discuss a project',
  },
  fr: {
    solutions: 'Solutions',
    system: 'Comment ça marche',
    projects: 'Projets',
    product: 'Social Manager',
    process: 'Méthode',
    contact: 'Parler de votre projet',
  },
};

const Header = ({ currentPath }: HeaderProps) => {
  const { i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const language = i18n.language?.startsWith('en') ? 'en' : i18n.language?.startsWith('fr') ? 'fr' : 'pt';
  const copy = labels[language];
  const isHomePage = currentPath === '/';
  const prefix = isHomePage ? '' : '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { name: copy.solutions, href: `${prefix}#solutions` },
    { name: copy.system, href: `${prefix}#system` },
    { name: copy.projects, href: '/projetos' },
    { name: copy.product, href: '/social-manager' },
    { name: copy.process, href: `${prefix}#process` },
  ];

  return (
    <header className={`maipro-header ${scrolled ? 'maipro-header-scrolled' : ''}`}>
      <div className="maipro-header-inner">
        <Link to="/" className="maipro-wordmark" aria-label="MAIPROSolutions home">
          <span>MAIPRO</span><strong>Solutions</strong>
        </Link>

        <nav className="maipro-desktop-nav" aria-label="Primary navigation">
          {navItems.map((item) => (
            <a key={item.name} href={item.href}>{item.name}</a>
          ))}
        </nav>

        <div className="maipro-header-actions">
          <LanguageToggle />
          <Link className="maipro-header-cta" to="/briefing">
            {copy.contact} <FiArrowUpRight />
          </Link>
        </div>

        <button
          type="button"
          className="maipro-menu-button"
          onClick={() => setMobileMenuOpen((open) => !open)}
          aria-label="Toggle navigation"
          aria-expanded={mobileMenuOpen}
        >
          {mobileMenuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="maipro-mobile-panel">
          <nav>
            {navItems.map((item) => (
              <a key={item.name} href={item.href} onClick={() => setMobileMenuOpen(false)}>{item.name}</a>
            ))}
            <Link className="maipro-mobile-cta" to="/briefing" onClick={() => setMobileMenuOpen(false)}>
              {copy.contact} <FiArrowUpRight />
            </Link>
          </nav>
          <div className="maipro-mobile-language"><LanguageToggle /></div>
        </div>
      )}
    </header>
  );
};

export default Header;
